/*
 * Scroll-reveal animator. Walks the DOM at load + on mutation, tags
 * eligible elements (top-level children of .ahu-section that look like
 * content) with the .ahu-reveal class, then uses IntersectionObserver
 * to add .is-visible when they enter the viewport.
 *
 * Skips:
 *   - Page-1 hero content (already visible at load; no point fading in)
 *   - Sticky / fixed elements (would cause layout glitches)
 *   - The header itself
 *   - Any element marked data-no-reveal
 */

(function () {
  if (window.__ahuRevealInit) return;
  window.__ahuRevealInit = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return; // CSS handles the no-animation case too

  var observer = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      var e = entries[i];
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        observer.unobserve(e.target);
      }
    }
  }, {
    rootMargin: '0px 0px -10% 0px',
    threshold: 0.05
  });

  function isAboveFold(el) {
    var r = el.getBoundingClientRect();
    // Reveal immediately (skip the fade) ONLY for content sitting right at the very top of the
    // page on load — i.e. behind/under the header. This used to be a viewport-RATIO cutoff
    // (0.6 * viewport height), which was the bug the client reported on mobile: under a short
    // (~320px) mobile hero the first content section landed well within 0.6*viewport, so it
    // counted as "above fold" and never animated — while on desktop the taller (~840px) hero
    // pushed that same section past the cutoff so it DID animate. A small FIXED px cutoff is
    // independent of viewport height and hero height, so the first section fades in the same
    // on mobile and desktop.
    return r.top < 100;
  }

  function shouldSkip(el) {
    if (el.hasAttribute('data-no-reveal')) return true;
    if (el.closest('[data-no-reveal]')) return true;
    if (el.closest('header, [data-ahu-header]')) return true;
    var pos = getComputedStyle(el).position;
    if (pos === 'fixed' || pos === 'sticky') return true;
    return false;
  }

  function tagAndObserve(el, delayIndex) {
    if (el.classList.contains('ahu-reveal')) return;
    if (shouldSkip(el)) return;
    if (typeof delayIndex === 'number' && delayIndex > 0 && delayIndex <= 5) {
      el.setAttribute('data-reveal-delay', String(delayIndex));
    }
    // Content sitting right at the very top of the page on load (behind the header) is shown
    // immediately — no fade.
    if (isAboveFold(el)) {
      el.classList.add('ahu-reveal');
      el.classList.add('is-visible');
      return;
    }
    // Otherwise snap the element straight to its hidden state with the transition SUPPRESSED,
    // so it commits opacity:0 without animating toward it first. Then the observer adds
    // .is-visible and it fades IN (0 -> 1). Without the snap, an element already on-screen at
    // load (e.g. the first section under a short mobile hero) only ever transitioned 1 -> 0 a
    // hair before .is-visible pulled it back to 1, so it never actually faded — the mobile bug.
    el.style.transition = 'none';
    el.classList.add('ahu-reveal');
    void el.offsetWidth; // force the opacity:0 / translateY start state to commit
    el.style.transition = '';
    observer.observe(el);
  }

  function scanSection(section) {
    // Reveal the direct children that look like visible content blocks:
    // headings, paragraphs, images, anchors, divs, sections, articles, lists.
    var blockTags = ['H1', 'H2', 'H3', 'H4', 'IMG', 'P', 'A', 'DIV', 'SECTION', 'ARTICLE', 'UL', 'OL', 'FIGURE', 'BLOCKQUOTE', 'BUTTON'];
    var children = section.children || [];
    var index = 0;
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (!c.tagName) continue;
      if (blockTags.indexOf(c.tagName) === -1) continue;
      tagAndObserve(c, index);
      index++;
    }
  }

  function scanDocument() {
    // Apply to every .ahu-section's direct content children.
    var sections = document.querySelectorAll('.ahu-section');
    for (var i = 0; i < sections.length; i++) scanSection(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanDocument, { once: true });
  } else {
    scanDocument();
  }

  // Catch sections that hydrate later (Shopify section rerenders, etc.).
  var moBouncer = false;
  var mo = new MutationObserver(function () {
    if (moBouncer) return;
    moBouncer = true;
    requestAnimationFrame(function () {
      moBouncer = false;
      scanDocument();
    });
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
